var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Edelicon from "@frameworks/web/components/generic/Edelicon";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import React, { useState, useRef, useEffect } from "react";
import { nanoid } from "nanoid";
import needhelp from "@frameworks/shared-library/assets/images/SalesJourney/need-help.svg";
export var EContactDetailsFor;
(function (EContactDetailsFor) {
    EContactDetailsFor["RM"] = "RM";
    EContactDetailsFor["client"] = "client";
    EContactDetailsFor["helpDesk"] = "helpDesk";
})(EContactDetailsFor || (EContactDetailsFor = {}));
var AOPOrderbookNeedHelp = function (props) {
    var uniqueIdForNeedHelpContainer = nanoid();
    var buttonRef = useRef(null);
    var _a = __read(useState(false), 2), showTooltip = _a[0], setShowTooltip = _a[1];
    var _b = __read(useState({
        email: "helpdesk@nuvama.com",
        phoneNumber: "1800-102-3335",
    }), 2), contactDetails = _b[0], setContactDetails = _b[1];
    var handleOnCloseIcon = function () {
        setShowTooltip(false);
    };
    var hanldleOnClickEmail = function () {
        var mailtoLink = "mailto:".concat(contactDetails.email);
        window.location.href = mailtoLink;
    };
    var handleOnClickPhone = function () {
        // Construct the tel URL
        var telLink = "tel:".concat(contactDetails.phoneNumber);
        // Open the tel link to initiate a call
        window.location.href = telLink;
    };
    useEffect(function () {
        // added this to handle the click event on the button div inside GenericTooltip component
        var handleClick = function () {
            setShowTooltip(function () { return true; });
        };
        var divElement = buttonRef.current;
        divElement === null || divElement === void 0 ? void 0 : divElement.addEventListener("click", handleClick);
        return function () {
            divElement === null || divElement === void 0 ? void 0 : divElement.removeEventListener("click", handleClick);
        };
    }, []);
    return (React.createElement("div", { className: "d-flex flex-row primary-need-help-container", id: uniqueIdForNeedHelpContainer },
        React.createElement(GenericTooltip, { container: function () { return document.getElementById(uniqueIdForNeedHelpContainer); }, toolTipClassName: "need-help-tooltip", placement: "top", triggerType: "click", externalClassName: "remove-btn-props", showTooltip: showTooltip, hasOuterShowState: true, toolTipText: React.createElement("div", { className: "d-flex flex-column gap-3" },
                React.createElement("div", { className: "d-flex justify-content-between need-help-header" },
                    React.createElement("label", { className: "DMsanR_11_400 text-decoration-underline" }, "Contact us"),
                    React.createElement("span", { onClick: handleOnCloseIcon },
                        React.createElement("i", { className: "edel-icon-cross-bold-small" }))),
                React.createElement("div", { className: "d-flex flex-column align-items-start gap-2" },
                    React.createElement("div", { role: "button", onClick: hanldleOnClickEmail, className: "d-flex align-items-center justify-content-center gap-2 hand_cursor" },
                        React.createElement(Edelicon, { className: "edel-icon-email-color", paths: 4 }),
                        React.createElement("label", { className: "DMSansNormal_12_400 text-decoration-underline hand_cursor" }, contactDetails.email)),
                    React.createElement("div", { role: "button", onClick: handleOnClickPhone, className: "d-flex align-items-center justify-content-center gap-2 hand_cursor" },
                        React.createElement(Edelicon, { className: "edel-icon-contact", paths: 3 }),
                        React.createElement("label", { className: "DMSansNormal_12_400 hand_cursor" }, contactDetails.phoneNumber)))), noButton: true, button: React.createElement("div", { ref: buttonRef, className: "need-help d-flex align-items-center gap-2" },
                React.createElement("img", { src: needhelp, alt: "need help" }),
                React.createElement("label", { className: "DMSansNormal_12_400" }, "Need Help?")) })));
};
export default AOPOrderbookNeedHelp;
